export default function Navbar() {
  return (
    <div className="bg-white border-gray-200 px-2 py-2.5 dark:bg-gray-900">
      <span className="text-xl font-semibold whitespace-nowrap dark:text-white">
        PassBase
      </span>
    </div>
  );
}
